/**
 * A standard custom button with loading if loading is true
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Spinner } from 'reactstrap';

function CustomButton({
  children,
  loading = false,
  disabled = false,
  className,
  shadow = false,
  btnRef = null,
  ...rest
}) {
  return (
    <Button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      className={classNames(className, {
        'show-spinner': loading,
        'btn-shadow': shadow,
      })}
      // if loading is defined override disable
      disabled={loading || disabled}
      ref={btnRef}
    >
      <Spinner size="sm" className="me-2">
        Loading...
      </Spinner>
      <span className="label">
        {children}
      </span>
    </Button>
  );
}

CustomButton.defaultProps = {
  children: null,
  loading: false,
  disabled: false,
  shadow: true,
  className: '',
  btnRef: null,
};

CustomButton.propTypes = {
  children: PropTypes.any,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  shadow: PropTypes.bool,
  className: PropTypes.string,
  btnRef: PropTypes.any,
};

export default CustomButton;
